//#region IMPORT
import React, { useEffect, useRef, useState } from 'react';
import { Button, Dialog } from '../MUIs';
import { AppBar, Box, IconButton, Toolbar, Typography } from '@mui/material';
import {
  Close as CloseIcon,
  Search as SearchIcon,
  Add as AddIcon,
  Save as SaveIcon,
  Delete as DeleteIcon,
  Print as PrintIcon,
} from '@mui/icons-material';
import { BusinessGridCommon } from '../BusinessGridCommon';
import {
  newYnErrorSnackbar,
  showSnackbar,
} from '../../Reducer/SnackbarReducer';
import GridCheckBox from '../Ui/GridCheckBox/GridCheckBox';
import GridCellFileUpload from '../Ui/GridCellFileUpload/GridCellFileUpload';
import { useDispatch, useSelector } from 'react-redux';
import Commons from '../../Services/Common/Common';
import Global from '../../Services/Common/Global';
import FileModalCommon from './FileModalCommon';
import dayjs from 'dayjs';
import useDelete from '../../hooks/useDelete';
import { setAddButtonErrorTrue } from '../../Reducer/StatusFlagsReducer';
//#endregion

function FileModalCommonF({
  modalTitle = '서식 관리',
  gridTitle = '서식 관리 기본 정보',
  extension = '',
  open = false,
  onClose = (e) => {},
  deletePayload1 = (e) => {},
  deleteUrl = '',
  searchPayload1 = (e) => {},
  saerchUrl = '',
  savePayload1 = (e) => {},
  saveUrl = '',
  saveFilePath1 = '',
  fileValidFc = (e) => {},
  custCd = '',

  props,
}) {
  //#region 변수
  const dispatch = useDispatch();
  const { userInfo, custInfo, lanInfo } = useSelector(
    (state) => state.BaseInfo
  );

  const [loading, setLoading] = useState(false);

  const [rowData1, setRowData1] = useState([]); //그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [changedRowData1, setChangedRowData1] = useState([]);
  const [deletedRowData1, setDeletedRowData1] = useState([]);

  const gridRef1 = useRef();
  const selectedRowNosRef1 = useRef(new Set());
  const lastCheckedIndexRef1 = useRef(null);
  //#endregion
  const getDeletePayload1 = (rows) => rows.map((row) => deletePayload1(row));

  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    getDeletePayload: getDeletePayload1,
    getDeleteUrl: deleteUrl,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });

  useEffect(() => {
    // ✅ 팝업이 열릴 때만 조회하도록 수정 (탭 이동 시에는 조회하지 않음)
    // 서식 버튼 클릭 시에만 조회가 되도록 함
    if (!open) return; // 팝업이 닫혀있으면 조회하지 않음

    // 일반 유저일 경우에 실행
    if (userInfo.authCd !== 'ADMIN') {
      Init();
      // 시스템 계정일 때
    } else {
      if (custCd) {
        // ✅ custCd 있을 때만 실행
        SearchLogic1();
      }
      return;
    }
  }, [open]); // ✅ open을 dependency에 추가

  // ✅ 두 번째 useEffect 제거 (서식 버튼 클릭 시 open이 true가 되면 첫 번째 useEffect에서 조회됨)

  const Init = async () => {
    SearchLogic1();
    try {
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  //#region 조회
  const SearchLogic1 = async () => {
    setLoading(true);
    setRowData1([]);
    ResetLogic();

    try {
      const searchData = searchPayload1();
      await Commons.Axios('post', saerchUrl, [searchData]).then((result) => {
        let data = result.data;

        if (data.length == 0) {
          dispatch(
            showSnackbar({
              message: '데이터가 없습니다.',
              type: 'info',
            })
          );
          // SearchLogic2();
        } else if (data[0]?.type === 'Error') {
          //Get할 땐 에러인 경우 인덱스 0 에 {type:"Error"} 로 반환되고, 에러가 아닐 경우엔 정상적인 데이터 반환
          dispatch(showSnackbar({ message: data[0].message, type: 'error' }));
          return false;
        } else {
          setRowData1(Commons.InsertNumber(data));
          // ResetLogic();
        }
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  //#region 저장
  // 서식 저장버튼 클릭 시 함수
  const SaveLogic1 = async () => {
    setLoading(true);

    try {
      const hasDelete = deletedRowData1.length > 0;
      const changedRows = changedRowData1.filter((row) => !row.deleteYn);
      const hasChange = changedRows.length > 0;

      if (!hasDelete && !hasChange) {
        dispatch(setAddButtonErrorTrue());
        dispatch(
          showSnackbar({
            message: '저장할 데이터가 없습니다.',
            type: 'warning',
          })
        );
        return;
      }
      // if (hasChange) {
      //   const invalidRows = changedRows.filter(
      //     (item) => !item.FILE_NAME || !item.FILE_NAME.trim()
      //   );
      //   if (invalidRows.length > 0) {
      //     dispatch(
      //       showSnackbar({
      //         message: '파일명을 입력하세요',
      //         type: 'error',
      //       })
      //     );
      //     return;
      //   }
      // }

      if (hasDelete) {
        try {
          await deleteHandler1.DeleteLogic();
        } catch (e) {
          console.log(e);
          dispatch(
            showSnackbar({
              message: '오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
              type: 'error',
            })
          );
          return;
        }
      }

      if (hasChange) {
        for (const item of changedRows) {
          item.mapFile && SaveLogic2(item.mapFile);
        }
        const saveData = changedRows.map((item) => savePayload1(item));

        try {
          const result = await Commons.Axios('post1', saveUrl, saveData);
          const data = result.data;

          if (data.length === 0) {
            dispatch(
              showSnackbar({
                message: '저장 후 반환된 값이 없습니다.',
                type: 'error',
              })
            );
            return;
          } else if (data?.[0]?.type === 'Error') {
            dispatch(
              showSnackbar({
                message: data[0].message || '에러가 발생했습니다.',
                type: 'error',
              })
            );
            return;
          } else {
          }
        } catch {
          dispatch(
            showSnackbar({
              message: '오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
              type: 'error',
            })
          );
          return;
        }
      }
      if (hasDelete && hasChange) {
        dispatch(
          showSnackbar({
            message: '저장 및 삭제가 완료되었습니다.',
            type: 'success',
          })
        );
      } else if (hasDelete) {
        dispatch(
          showSnackbar({
            message: '삭제되었습니다.',
            type: 'warning',
          })
        );
      } else if (hasChange) {
        dispatch(
          showSnackbar({
            message: '저장되었습니다.',
            type: 'success',
          })
        );
      }

      await SearchLogic1();
    } catch (e) {
      console.error(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: e.code === 'CUSTOM_ERROR' ? e.type : 'error',
        })
      );
    } finally {
      setLoading(false);
    }
  };
  // 서식 파일 저장
  const SaveLogic2 = async (_file) => {
    setLoading(true);
    let formList = new FormData();
    try {
      formList.append('value1', Commons.EncryptAES(userInfo.userid));
      formList.append('value2', Commons.EncryptAES(saveFilePath1)); //주소
      formList.append('value3', _file);

      await Commons.Axios(
        'file',
        Global.base.useUrl + Global.urls.Execute.ftpRequest,
        null,
        formList
      ).then((result) => {
        let data = result.data;

        if (data) {
          if (data[0].type === 'Error') {
            dispatch(showSnackbar({ message: data[0].message, type: 'error' }));

            return false;
          }
        }
      });
    } catch (e) {
      console.log('Error: ', e);
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  //#region 나머지 함수
  // 파일 다운로드
  const DownloadLogic1 = async (_data) => {
    await Commons.Axios(
      'post',
      Global.base.useUrl + Global.urls.Execute.ftpResponse,
      {
        value1: Commons.EncryptAES(_data.filePath),
      }
    ).then((result) => {
      let data = result.data;

      if (data !== 'Error') {
        // Base64 데이터를 Blob으로 변환
        const pdfBlob = new Blob(
          [Uint8Array.from(atob(data), (c) => c.charCodeAt(0))],
          {
            type: 'application/octet-stream', // 일반 바이너리 파일
          }
        );

        const fileName = _data.FILE_NAME;

        const downloadLink = document.createElement('a');
        const blobUrl = URL.createObjectURL(pdfBlob);
        downloadLink.href = blobUrl;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        // 메모리 해제
        URL.revokeObjectURL(blobUrl);
      } else {
        dispatch(
          showSnackbar({
            message: '저장 후 파일 다운로드가 가능합니다.',
            type: 'warning',
          })
        );
      }
    });
  };

  const HandleRowSelection = (rowData, rowIndex) => {
    setSelectedRowData1([rowData]);
  };
  const ResetLogic = () => {
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    gridRef1?.current?.api?.deselectAll();
  };
  //#endregion

  return (
    <FileModalCommon
      modalTitle={modalTitle}
      gridTitle={gridTitle}
      extension={extension}
      open={open}
      onClose={onClose}
      userInfo={userInfo}
      rowData1={rowData1}
      setRowData1={setRowData1}
      selectedRowData1={selectedRowData1}
      setSelectedRowData1={setSelectedRowData1}
      changedRowData1={changedRowData1}
      setChangedRowData1={setChangedRowData1}
      deletedRowData1={deletedRowData1}
      setDeletedRowData1={setDeletedRowData1}
      gridRef1={gridRef1}
      selectedRowNosRef1={selectedRowNosRef1}
      lastCheckedIndexRef1={lastCheckedIndexRef1}
      dispatch={dispatch}
      showSnackbar={showSnackbar}
      // 함수
      SearchLogic1={SearchLogic1}
      SaveLogic1={SaveLogic1}
      DownloadLogic1={DownloadLogic1}
      HandleRowSelection={HandleRowSelection}
      RestoreRow1={deleteHandler1.RestoreRow}
      MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
      DeleteNewRow1={deleteHandler1.DeleteNewRow}
    />
  );
}

export default FileModalCommonF;
